import {useLocation} from "react-router-dom";
import {ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import theme from "../../../../util/theme";
import PropTypes from "prop-types";
import {ExpandLess, ExpandMore} from "@mui/icons-material";
import {customMatchPath} from "../../../../util/customMatchPath";
import Typography from "@mui/material/Typography";

const CustomListItem = ({item, handleItemClick, open, openCollapse}) => {
    const location = useLocation();
    return (
        <ListItem
            disablePadding
            sx={{
                display: 'block',
                mb: 2,
                color: item.subItems && customMatchPath(item.pattern, location.pathname) ? theme.palette.primary.main : "default",
                backgroundColor:
                item.subItems ? "#333333" :
                    customMatchPath(item.pattern, location.pathname)
                        ? theme.palette.primary.main
                        : '#333333',
                '&:hover': {
                    backgroundColor:
                    item.subItems ? "#333333" :
                        customMatchPath(item.pattern, location.pathname)
                            ? theme.palette.secondary.main
                            : '#ffc000',
                },
                borderRadius: 1,
            }}
        >
            <ListItemButton
                sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    borderRadius: 1,
                }}
                onClick={() => handleItemClick(item.route)}
            >
                <ListItemIcon
                    sx={{
                        minWidth: 0,
                        mr: open ? 1 : 'auto',
                        justifyContent: 'center',
                        color: item.subItems && customMatchPath(item.pattern, location.pathname) ? theme.palette.primary.main : 'white',
                    }}
                >
                    {item.icon}
                </ListItemIcon>
                <ListItemText
                    primary={<Typography sx={{fontSize:"15px"}}>{item.text}</Typography>}
                    sx={{
                        opacity: open ? 1 : 0,
                    }}
                />
                {open && item.subItems ? (openCollapse ? <ExpandLess/> : <ExpandMore/>) : null}
            </ListItemButton>
        </ListItem>
    )
}

CustomListItem.propTypes = {
    open: PropTypes.bool,
    handleItemClick: PropTypes.func,
    location: PropTypes.any,
    item: PropTypes.shape({
        text: PropTypes.object.isRequired,
        route: PropTypes.string,
        pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        icon: PropTypes.object
    })
}

export default CustomListItem;